import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql.canvasflow.io",
        "subdirectory": "/",
        "website": "https://starmagazine.com/",
        "assetDirectory": "/",
        "title": "Star Magazine",
        "shortTitle": "Star",
        "appKey": "150b70af-b4fa-4baf-81be-7dfb592a8236",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "<p><a href=\"https://starmagazine.com/terms-of-use/\" target=\"_blank\" rel=\"noreferrer\">Terms of Use</a></p><p><a href=\"https://starmagazine.com/privacy-policy/\" target=\"_blank\" rel=\"noreferrer\">Privacy Policy</a></p><p><div class=\"optanon-toggle-display\" style=\"margin: 0px 10px;\">Do Not Sell</div></p><p><a href=\"https://starmagazine.com/cookie-policy/\" target=\"_blank\" rel=\"noreferrer\">Cookie Policy</a></p>",
        "buildNumber": 198957,
        "version": "2.9.6"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "login",
            "host": ""
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "magazine",
            "config": {
                "featureArticles": true
            }
        },
        "legal": {
            "tou": {
                "url": "https://starmagazine.com/terms-of-use/",
                "label": "Terms of Use"
            },
            "privacy": {
                "url": "https://starmagazine.com/privacy-policy/",
                "label": "Privacy Policy"
            },
            "cookie": {
                "url": "https://starmagazine.com/cookie-policy/",
                "label": "Cookie Policy"
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 5,
                "previewIssue": 5,
                "getIssue": 5,
                "getFeatureArticles": 5,
                "styles": 5
            }
        },
        "menu": {
            "links": [
                {
                    "title": "Terms of Use",
                    "icon": "",
                    "url": "https://starmagazine.com/terms-of-use/"
                },
                {
                    "title": "Privacy Policy",
                    "icon": "",
                    "url": "https://starmagazine.com/privacy-policy/"
                },
                {
                    "title": "Cookie Policy",
                    "icon": "",
                    "url": "https://starmagazine.com/cookie-policy/"
                }
            ]
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 0
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;